export enum widgetTrigger {
    OPEN = 'open',
    CLOSE = 'close',
}